import type { TaskListFilter } from '@pm-tool/shared';
import { filtersOf, parseListSearch } from '@/features/tasks/list-search';

/** URL state of the board (KAN-04): the list filters, swimlanes and the open task. */
export type BoardSearch = TaskListFilter & { lanes?: true; task?: string };

export function parseBoardSearch(raw: Record<string, unknown>): BoardSearch {
  const list = parseListSearch(raw);
  const search: BoardSearch = filtersOf(list);
  if (raw.lanes === true || raw.lanes === 'true') search.lanes = true;
  if (list.task !== undefined) search.task = list.task;
  return search;
}

export function boardFilters(search: BoardSearch): TaskListFilter {
  const filters = { ...search };
  delete filters.lanes;
  delete filters.task;
  return filters;
}

export function withBoardTask(search: BoardSearch, key: string | undefined): BoardSearch {
  const next = { ...search };
  if (key === undefined) delete next.task;
  else next.task = key;
  return next;
}
